import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
 *@author   tonicli
 *@date     2017/11/13
 */
import KVParser from "./KVParser";
import { rpcCGI } from "./request";
import { hasOwn } from "./util";
var kvParser = new KVParser({
  seperator: '|',
  kvSeperator: '=',
  skipEmpty: true,
  decode: true
});

function _parse(aid) {
  aid = decodeURIComponent(aid);

  if (!/^(V0|V1)\$/.test(aid)) {
    throw new Error('[@tencent/vft-common.AID._parse]invalid aid');
  }

  var _aid$match = aid.match(/^(V\d+\$)([^|]*)(\|(.*))?/),
      _aid$match2 = _slicedToArray(_aid$match, 5),
      protocol = _aid$match2[1],
      content = _aid$match2[2],
      remark = _aid$match2[4];

  var data = {};
  var reg = /\$(\d+):([^$]+)/g;
  var match;

  while (match = reg.exec(content)) {
    data[match[1]] = decodeURIComponent(match[2]);
  }

  return {
    protocol: protocol,
    data: data,
    remarks: remark ? kvParser.parse(remark) : {}
  };
}
/* eslint-disable key-spacing */


var KEY_MAP = {
  channel: '1',
  // 视频app启动渠道
  plat: '2',
  // 平台号
  version: '3',
  // 版本号
  source: '4',
  // 一级来源
  cid: '5',
  // 视频 cid
  vid: '6',
  // 视频 vid
  pid: '7',
  // 直播id
  source2: '8',
  // 二级来源
  channelId: '9',
  // 频道id
  scene: '11',
  // 支付场景
  ptag: '12',
  // ptag
  actid: '13',
  // 玉柱id
  serial: '15',
  // 连续包套餐类型，区分包月、包季、包年
  voucher: '21',
  // 优惠券
  payway: '25',
  // 支付方式，区分微信支付、Q币等
  vuid: '28',
  // 视频 vuserid
  device: '29',
  // 设备id
  exper: '30',
  // 实验id
  bucketid: '31',
  // abtest专用id
  bizType: '32',
  // 业务类型， 1->礼品卡 2->邀请有礼 3->亲密付
  appid: '33',
  // APPID，用于海外版，该值与付费后台的 bid 对应,
  app: '34',
  // APP，1->腾讯视频国内版(包含web、h5) 2->极速版 3->微信小程序 5->小企鹅乐园
  vmid: '38',
  // NBA比赛id
  blid: '39',
  // 支持对同一CID设置不同付费类型，用blid来定义不同业务线
  said: '41',
  // 新增超长的41vid，获取短链
  salesIp: '42',
  // 分销平台,上报格式为“业务编码_分发者id_业务个性化信息”
  chid: '43',
  // 直播机位id
  taskId: '44',
  // 推广位id
  orderId: '45',
  // 订单id
  tvPtChid: '46',
  // tv扫码场景上报pt+chid:SNMAPP16158
  liveScene: '48',
  // 直播场景信息
  liveGid: '49',
  // 场次id，用于陪看场景
  roomId: '50' // 房间id，用于陪看、一起看场景

}; // https://iwiki.woa.com/pages/viewpage.action?pageId=151864803
// 2021年10月26日增加直播机位id上报，调整排序
// 2022年2月21日增加tv扫码场景46级，调整排序
// 2022年8月16日增加陪看场景48、49、50级，调整排序

var LEVEL_ORDER = [41, 2, 46, 4, 13, 38, 5, 7, 43, 6, 39, 22, 36, 37, 47, 32, 28, 23, 15, 12, 30, 33, 11, 48, 49, 50, 8, 29, 31, 21, 3];
var LEVEL_PRIORITY = {};

for (var i = 0, len = LEVEL_ORDER.length; i < len; i++) {
  LEVEL_PRIORITY[LEVEL_ORDER[i]] = i + 1;
}

function _key2level(key) {
  return KEY_MAP[key] || '';
}

function _transPriority(order) {
  var priority = {};

  for (var _i = 0, _len = order.length; _i < _len; _i++) {
    priority[order[_i]] = _i + 1;
  }

  return priority;
}

var DEFAULT_ENCRYPT_APPID = 'common';

var AID = /*#__PURE__*/function () {
  function AID(aid) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$appid = _ref.appid,
        appid = _ref$appid === void 0 ? DEFAULT_ENCRYPT_APPID : _ref$appid;

    _classCallCheck(this, AID);

    _defineProperty(this, "_appid", '');

    _defineProperty(this, "_protocol", 'V0$');

    var data = aid ? _parse(aid) : {
      protocol: 'V0$',
      data: {},
      remarks: {}
    };
    this._aid = decodeURIComponent(aid);
    this._protocol = data.protocol;
    this._data = data.data;
    this._remarks = data.remarks;
    this._priority = LEVEL_PRIORITY;
    this._appid = appid;
  }

  _createClass(AID, [{
    key: "set",
    value: function set(level, val) {
      var _this = this;

      if (_typeof(level) === 'object') {
        Object.keys(level).forEach(function (k) {
          _this._set(k, level[k]);
        });
      } else {
        this._set(level, val);
      }

      return this;
    }
  }, {
    key: "_set",
    value: function _set(level, val) {
      level = this._transLevel(level);
      this._data[level] = val;
      return this;
    }
  }, {
    key: "get",
    value: function get(level) {
      var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      level = this._transLevel(level);
      var v = this.has(level) ? this._data[level] : '';
      return full ? this._buildOne(level, v) : v;
    }
  }, {
    key: "has",
    value: function has(level) {
      return Object.prototype.hasOwnProperty.call(this._data, this._transLevel(level));
    }
  }, {
    key: "toString",
    value: function toString(order) {
      var aid = this._protocol;
      var priority = order ? _transPriority(order) : this._priority;
      var levels = Object.keys(this._data);
      var len = levels.length;
      levels.forEach(function (v, i) {
        if (!hasOwn(priority, v)) {
          priority[v] = 99999 - (len - i);
        }
      });
      var p = levels.sort(function (a, b) {
        return (priority[a] || 99999) - (priority[b] || 99999);
      });

      var _iterator = _createForOfIteratorHelper(p),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var k = _step.value;
          aid += this._buildOne(k, this._data[k]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return aid + this._buildRemarks();
    }
  }, {
    key: "setProtocol",
    value: function setProtocol(protocol) {
      this._protocol = protocol;
    }
  }, {
    key: "protocol",
    value: function protocol() {
      return this._protocol;
    }
  }, {
    key: "setRemark",
    value: function setRemark(k, v) {
      this._remarks[k] = v;
    }
  }, {
    key: "getRemark",
    value: function getRemark(k) {
      return hasOwn(this._remarks, k) ? this._remarks[k] : '';
    }
  }, {
    key: "clearRemark",
    value: function clearRemark(k) {
      delete this._remarks[k];
    }
  }, {
    key: "_buildOne",
    value: function _buildOne(level, val) {
      return "$".concat(level, ":").concat(this._needEncode(level) ? encodeURIComponent(val) : val);
    }
  }, {
    key: "_needEncode",
    value: function _needEncode(level) {
      level = parseInt(level, 10);
      return level === 12 || level === 13;
    }
  }, {
    key: "_transLevel",
    value: function _transLevel(level) {
      if (/^\d+$/.test(level)) {
        return level;
      }

      return _key2level(level);
    }
  }, {
    key: "_buildRemarks",
    value: function _buildRemarks() {
      var _this2 = this;

      var r = '';
      Object.keys(this._remarks).forEach(function (k) {
        r += "|".concat(k, "=").concat(encodeURIComponent(_this2._remarks[k]));
      });
      return r;
    }
  }, {
    key: "setOrder",
    value: function setOrder(order) {
      this._priority = _transPriority(order);
    }
  }, {
    key: "encode",
    value: function () {
      var _encode2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var enableFallback,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                enableFallback = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                _context.prev = 1;
                _context.next = 4;
                return _encode("".concat(this), this._appid);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                if (!enableFallback) {
                  _context.next = 12;
                  break;
                }

                console.warn('[@tencent/vft-common/AID.encode]fail to encode AID. Use full aid as fallback');
                return _context.abrupt("return", "".concat(this));

              case 12:
                throw _context.t0;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function encode() {
        return _encode2.apply(this, arguments);
      }

      return encode;
    }()
  }]);

  return AID;
}();

export { AID as default };

AID.getParam = function (level, aid) {
  if (!/^[1-9]\d*$/.test(level)) {
    return '';
  }

  if (!/^V0\$/.test(aid)) {
    return '';
  }

  var match = decodeURIComponent(aid).match(new RegExp("\\$".concat(level, ":([^\\$]*)")));
  return match && match.length > 1 ? match[1] : '';
};

function _encode(_x) {
  return _encode3.apply(this, arguments);
}

function _encode3() {
  _encode3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(aid) {
    var appid,
        _yield$rpcCGI,
        encodedKey,
        encodedAid,
        _args2 = arguments;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            appid = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : DEFAULT_ENCRYPT_APPID;

            if (!(typeof aid !== 'string' || aid.length === 0)) {
              _context2.next = 3;
              break;
            }

            throw new Error('[@tencent/vft-common/AID/encode]aid must be a non-empty string');

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return rpcCGI('trpc.vipwater.vip_aid_codec.VipAidCodec/Encode', {
              origin_key: aid,
              appid: appid
            });

          case 6:
            _yield$rpcCGI = _context2.sent;
            encodedKey = _yield$rpcCGI.encoded_key;
            encodedAid = new AID();
            encodedAid.set(41, encodedKey);
            encodedAid.setProtocol('V1$');
            return _context2.abrupt("return", "".concat(encodedAid, "$"));

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](3);
            throw new Error('[@tencent/vft-common/AID/encode]failed to generate encoded key');

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 14]]);
  }));
  return _encode3.apply(this, arguments);
}

export { _encode as encode };
export var BizType = {
  GIFT: 1,
  INVITE: 2,
  FAMILY: 3
};